import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import Select from "react-select";
import { WebEngage, GA } from "../../../integrations";
import { PAGE_TYPE } from "../../../constants";
import { fetchConstituencyDetail, fetchCandidatesList } from "../../../api";
import styles from "./styles.m.css";
import { Icon } from "../../atoms/icon";
import LoksabhaElectionSearchBar from "../../rows/loksabha-election-dropdown";
import assetify from "@quintype/framework/assetify";
import loader from "../../../../assets/images/loader.gif";
import LoksabhaElectionCommentsWidget from "../../rows/loksabha-election-comment-widget";
import { convertInteger } from "../../utils/utils";
import StoryCardVertical from "../../atoms/story-card-vertical";

const StoryList = ({ stories }) => {
  // const limitedStories = stories.slice(0, 12);

  return (
    <React.Fragment>
      {stories.length > 0 ? (
        stories.map((story, idx) => (
          <div key={idx} className={styles["story-card"]}>
            <StoryCardVertical story={story} key={story.id} />
          </div>
        ))
      ) : (
        <h3 className={styles["no-results"]}>No results found</h3>
      )}
    </React.Fragment>
  );
};

StoryList.propTypes = {
  stories: PropTypes.arrayOf(StoryCardVertical.propTypes.story)
};

class AutoSelectComponent extends React.Component {
  logChange = val => {
    const { SelectedValue } = this.props;
    SelectedValue(val.value);
  };

  render() {
    const { options, className } = this.props;
    return <Select className={styles[className]} options={options} onChange={this.logChange} />;
  }
}

AutoSelectComponent.propTypes = {
  options: PropTypes.array,
  SelectedValue: PropTypes.func,
  className: PropTypes.string
};

const LoksabhaDetailPage = ({ data }) => {
  const [constituency, setConstituency] = useState([]);
  const [candidatesList, setCandidatesList] = useState({});
  const slug = get(data, ["slug"], "");
  const stories = get(data, ["stories"], null);
  useEffect(() => {
    fetchConstituencyDetail(slug)
      .then(res => {
        console.log("res-det", res);
        const resData = get(res, ["data", "items"]);
        setConstituency(resData);
      })
      .catch(console.error);
    WebEngage.registerPageView();
    GA.registerPageView(PAGE_TYPE.LOKSABHA_ELECTION_PAGE, { collection: data.collection });
  }, []);

  useEffect(() => {
    fetchCandidatesList(slug)
      .then(res => {
        console.log("res", res);
        const resData = get(res, ["data", "items", "constituency_info"], null);
        resData && setCandidatesList(resData);
      })
      .catch(console.error);
  }, []);

  const entries = Object.entries(candidatesList);

  const slidesWithClasses =
    entries !== 0 &&
    entries.map((slide, idx) => {
      return (
        <div className={styles["box-div"]} key={"slide-" + idx}>
          <div className={styles["title"]}>
            <h1>{slide[1].team_name}</h1>
          </div>
          <div className={styles["other-img"]}>
            {slide[1].star_candidate !== 0 ? <Icon type="star" className={styles["star-icon"]} /> : ""}
            <img
              // eslint-disable-next-line max-len
              src={`${slide[1].candidate_image}`}
              className={styles["mem-img"]}
            />
          </div>
          <h1>
            {slide[1].candidate_name} <span>({slide[1].party_name})</span>
          </h1>
        </div>
      );
    });

  const title = get(constituency, ["area"], null);

  const pic = get(constituency, ["area_image"], null);
  let description = get(constituency, ["description"], "");
  description = description.replace(/(<([^>]+)>)/gi, "");
  const femaleVoters = get(constituency, ["female_voters"], 0);
  const maleVoters = get(constituency, ["male_voters"], 0);
  const othersVoters = get(constituency, ["others"], 0);
  const MlaPic = get(constituency, ["current_mla_image"], null);

  // const ennaSeitharMla = get(constituency, ["enna_seithar_mla"], null);
  const currentMla = get(constituency, ["current_mla"], null);
  const currentMlaParty = get(constituency, ["current_mla_party"], null);
  // const districtName = get(constituency, ["district_name"], null);
  const storyLink = get(constituency, ["article_id"], null);
  const totalPeople = convertInteger(femaleVoters) + convertInteger(maleVoters) + convertInteger(othersVoters);
  // const thumb = get(constituency, ["current_mla_thumbs"], null);
  const constituencySlug = get(constituency, ["thokkuthi_slug"], null);
  // const partyId = get(constituency, ["party_id"], null);
  const vetpalarkalOption = entries.length !== 0 && (
    <div className={styles["other-members-wrapper"]}>
      <h2>{title} வேட்பாளர்கள் </h2>
      <div className={`${styles["other-members-slider"]}`}>{slidesWithClasses}</div>
    </div>
  );
  const firstOption = (
    <div>
      <div className={styles["lok-sabha-election"]}>
        <div className={styles["lok-sabha-election-detail"]}>
          <div className={`${styles["consti-first-grid"]}`}>
            <div className={`${styles["consti-main-sec"]}`}>
              <div className={`${styles["consti-main-sec-wrap"]}`}>
                {title && <h1>{`${title} எம்பி (லோக்சபா) தேர்தல் 2024`}</h1>}
                {pic && <img src={pic} />}
              </div>
              <div className={`${styles["mla-detail"]}`}>
                <h2>தற்போதைய நாடாளுமன்ற உறுப்பினர்</h2>
                <div className={`${styles["mla-detail-content"]}`}>
                  <img src={MlaPic} className={styles["mla-pic"]} />
                  <div className={`${styles["mla-question"]}`}>
                    {/* <div>
                      <h2>என்ன செய்தார் எம்.எல்.ஏ?</h2>
                      <img src={thumb} width="80" />
                    </div> */}
                    {/* {storyLink && ( */}
                    <div className={`${styles["mla-name"]}`}>
                      {currentMla} <span>{currentMlaParty}</span>
                    </div>
                    <Link
                      aria-label={`${"Read full story: "}`}
                      href={`${storyLink}?pfrom=constituency-page`}
                      externalLink={storyLink}
                      className={`${styles["read-more-link"]}`}
                    >
                      என்ன செய்தார் எம்.பி? <Icon type="double-arrow" />
                    </Link>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
            <div className={`${styles["consti-sec-sec"]}`}>
              {/* <div className={`${styles["consti-dist-sec"]}`}>
                <div className={`${styles["consti-dist-grid"]}`}>
                  <span className={`${styles["consti-dist-label"]}`}>மாவட்டம்</span>
                  <span className={`${styles["consti-dist-name"]}`}>{districtName}</span>
                </div>
                <div className={`${styles["consti-dist-grid"]}`}>
                  <span className={`${styles["consti-dist-label"]}`}>சட்டமன்றத் தொகுதி</span>
                  <span className={`${styles["consti-dist-name"]}`}>{title}</span>
                </div>
              </div> */}
              <div className={`${styles["consti-sec-sec-wrap"]}`}>
                <div className={`${styles["people-count"]}`}>
                  <h1>
                    மொத்தம் <span>{totalPeople.toLocaleString()}</span>
                  </h1>
                  <div className={`${styles["votecount"]}`}>
                    <img src="https://media.vikatan.com/vikatan/2021-03/2067d6de-28c2-4f63-a294-cedf4672f9a5/male.png" />
                    <div>
                      <h2>ஆண்கள்</h2>
                      <div>{maleVoters}</div>
                    </div>
                  </div>
                  <div className={`${styles["votecount"]}`}>
                    <img src="https://media.vikatan.com/vikatan/2021-03/3b51e7f1-9fec-47d6-8985-ce84bc4fada1/female.png" />
                    <div>
                      <h2>பெண்கள்</h2>
                      <div>{femaleVoters}</div>
                    </div>
                  </div>
                  <div className={`${styles["votecount"]}`}>
                    <img src="https://media.vikatan.com/vikatan/2021-03/c4f95fdb-d2db-4c72-b184-e4e1af726574/transgender.png" />
                    <div>
                      <h2>மூ.பாலினத்தவர்</h2>
                      <div>{othersVoters}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {description && (
              <div>
                <p className={styles["lok-shaba-desc"]}>
                  <span dangerouslySetInnerHTML={{ __html: description }} />
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {vetpalarkalOption}

      <div>
        <LoksabhaElectionCommentsWidget slug={slug} />
      </div>
      <div className={styles["third-op"]}>
        {title && <h2>{`நாடாளுமன்றத் தேர்தல் 2024 - ${title} தொகுதி`}</h2>}
        <div className={styles["lok-sabha-story"]}>
          <StoryList stories={stories} />
        </div>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <div className={`main-page styles-m__base__2vtxy js-story-main-container ${styles["base-class"]}`}>
        <div />
        <div className="page-content infinity-page">
          <div className={`container ${styles["story-grid"]}`}>
            <div className={`${styles["main-container"]}`}>
              <ul className={styles["breadcrumb-wrapper"]}>
                <li className={`${styles["breadcrumb"]}`}>
                  <Link aria-label={`breadcrumb`} href="/">
                    முகப்பு
                  </Link>
                </li>
                <li className={`${styles["breadcrumb"]}`}>
                  <Link aria-label={`breadcrumb`} href="/election/lok-sabha-election-2024">
                    நாடாளுமன்றத் தேர்தல் 2024
                  </Link>
                </li>
                <li className={`${styles["breadcrumb"]}`}>
                  <Link
                    aria-label={`இங்கு க்ளிக் செய்க`}
                    // eslint-disable-next-line max-len
                    href={`/election/lok-sabha-election-2024/constituency/${constituencySlug}`}
                  >
                    {title}
                  </Link>
                </li>
              </ul>
              <div className={styles["districk-dropdown"]}>
                <LoksabhaElectionSearchBar slug={slug} />
              </div>
              <div>
                {title ? firstOption : <img alt="Vikatan" src={assetify(loader)} className={styles["loader"]} />}
              </div>
              {/* <h2 className={styles["third-tab-details"]}>{slidesWithClasses}</h2> */}

              {/* <Tabs selectedIndex={tabIndex} onSelect={index => handleTabs(index)}>
                <TabList>
                  <Tab>தொகுதி கண்ணோட்டம்</Tab>
                  <Tab>பிரச்னைகள்</Tab>
                  <Tab>வேட்பாளர்கள்</Tab>
                </TabList>

                <TabPanel>
                  {title ? firstOption : <img alt="Vikatan" src={assetify(loader)} className={styles["loader"]} />}
                </TabPanel>
                <TabPanel>{secondOption}</TabPanel>
                <TabPanel>
                  <h2 className={styles["third-tab-details"]}>{slidesWithClasses}</h2>
                </TabPanel>
              </Tabs> */}
            </div>
          </div>
        </div>

        <div />
      </div>
    </React.Fragment>
  );
};
export { LoksabhaDetailPage };

LoksabhaDetailPage.propTypes = {
  data: PropTypes.shape()
};
